import { h } from 'preact'
import { BeaconPanel } from './BeaconPanel.jsx'

/**
 * BeaconWidget — root component mounted by beacon_controller.js on <body>.
 * Renders only the panel (when open) — the launcher button itself is plain
 * server-rendered HTML in application.html.erb, painted at first load
 * instead of popping in once this Preact bundle mounts.
 */
export function BeaconWidget({ store }) {
  const isOpen = store.isOpen.value

  return isOpen ? <BeaconPanel store={store} /> : null
}
